export interface GameConfigData {
  label: string;
  value: string;
  key: string;
  amsChannelId?: string;
  amsSystemId?: string;
  amsPartitionId?: string;
}

export interface GameConfig {
  systemData: GameConfigData[];
  channelData: GameConfigData[];
  partitionData: GameConfigData[];
}

const loadScript = scriptUrl => new Promise((resolve) => {
  const script = document.createElement('script');
  script.src = scriptUrl;
  script.type = 'text/javascript';
  // script.crossOrigin = 'anonymous';
  script.onload = () => {
    resolve(true);
  };
  script.onerror = () => {
    // todo report
    resolve(null);
  };
  document.getElementsByTagName('head')[0].appendChild(script);
});
const MAX_RETRY_COUNT = 3;
const GAME_CONFIG_URL = 'https://gameact.qq.com/comm-htdocs/js/game_area/utf8verson/gameId_server_select_utf8.js';
export const loadGameConfig = async (gameId, retryCount = 0): Promise<GameConfig | null> => {
  if (retryCount > MAX_RETRY_COUNT) return null;
  const scriptUrl = GAME_CONFIG_URL.replace('gameId', gameId);
  const res: any = await loadScript(scriptUrl);

  if (!res) {
    return loadGameConfig(gameId, retryCount + 1);
  }

  const key = `${gameId.toUpperCase()}ServerSelect`;

  const { STD_SYSTEM_DATA: systemData, STD_CHANNEL_DATA: channelData, STD_DATA: partitionData } = window[key] || {};

  return {
    systemData: systemData?.length ? formatGameConfig(systemData) : [],
    channelData: channelData?.length ? formatChannelConfig(channelData, gameId) : [],
    partitionData: partitionData?.length ? formatPartitionConfig(partitionData, gameId) : [],
  };
};

const formatGameConfig = data => data.map(item => ({
  value: item.v,
  label: item.t,
  key: item.k,
}));

const formatChannelConfig = (data, gameId) => {
  if (gameId === 'nfsm') {
    // 极品飞车不区分qq或者微信
    return data.map((item) => {
      const newValue = item.k === 'qq' ? '2' : item.v;
      return {
        value: newValue,
        label: item.t,
        key: item.k,
      };
    });
  }
  // 处理海岛奇兵不规范的数据结构
  if (gameId === 'bbb') {
    // 把data中v值一样的合并，label用斜杠分隔
    const mergedData = {};
    data.forEach((item) => {
      if (mergedData[item.v]) {
        mergedData[item.v].label += `/${item.t}`;
        return;
      }
      mergedData[item.v] = {
        value: item.v,
        label: item.t,
        key: item.k,
      };
    });
    return Object.values(mergedData);
  }
  return data.map((item) => ({
    value: item.v,
    label: item.t,
    key: item.k,
  }));
};

const formatPartitionConfig = (data, gameId) => {
  if (gameId === 'nfsm') {
    // 极品飞车不区分qq或者微信
    return data.map(item => ({
      value: item.v,
      label: item.t,
      amsSystemId: item.s,
      amsChannelId: item.ck === 'weixin' ? '1' : '2',
      amsPartitionId: item.v,
    }));
  }
  if (gameId === 'bbb') {
    // 过滤掉v值+s值一样的，只保留一个
    const uniqueData = {};
    data.forEach((item) => {
      const key = `${item.v}_${item.s}_${item.c}`;
      if (!uniqueData[key]) {
        uniqueData[key] = {
          value: item.v,
          label: item.t,
          amsSystemId: item.s,
          amsChannelId: item.c,
          amsPartitionId: item.v,
        };
      }
    });
    return Object.values(uniqueData);
  }
  return data.map((item) => ({
    value: item.v,
    label: item.t,
    amsSystemId: item.s,
    amsChannelId: item.c,
    amsPartitionId: item.v,
  }));
};
